import { Chapter, Reveal } from "@/components/landing/Reveal";

const FORMATS = [
  {
    id: "documentaries",
    index: "F—01",
    title: "Documentaries",
    desc: "Deep research-driven storytelling.",
  },
  {
    id: "podcasts",
    index: "F—02",
    title: "Podcasts",
    desc: "Structured long-form conversations and narratives.",
  },
  {
    id: "explainers",
    index: "F—03",
    title: "Explainers",
    desc: "Complex subjects transformed into accessible stories.",
  },
];

export default function Formats() {
  return (
    <section id="built-for" className="relative bg-[#0C0C0C] py-28 sm:py-36" data-testid="formats-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Chapter index="04" label="Built for Documentaries" testid="formats-chapter" />

        <Reveal>
          <h2
            className="max-w-3xl font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl"
            data-testid="formats-section-title"
          >
            Built for stories that deserve <span className="text-[#D4AF37]">more than a prompt.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-8 max-w-2xl text-base leading-relaxed text-[#9A9A9A] sm:text-lg">
          <p>
            pitsora is being designed for long-form content where research, context, evidence,
            narrative structure, and visual storytelling matter.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {FORMATS.map((format, i) => (
            <Reveal key={format.id} delay={i * 0.1} className="h-full">
              <div
                className="group relative flex h-full min-h-[380px] flex-col justify-between overflow-hidden border border-white/8 bg-[#111111] p-8 transition-colors duration-500 hover:bg-[#141414] sm:min-h-[440px]"
                data-testid={`format-${format.id}`}
              >
                <span
                  className="absolute left-0 top-0 h-[2px] w-0 bg-[#D4AF37] transition-[width] duration-700 group-hover:w-full"
                  aria-hidden="true"
                />
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] tracking-[0.3em] text-[#666666]">{format.index}</span>
                  <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">
                    <span className="h-1 w-1 rounded-full bg-[#D4AF37]" />
                    Part of the vision
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-[#F5F5F5] transition-colors duration-500 group-hover:text-[#D4AF37] sm:text-3xl">
                    {format.title}
                  </h3>
                  <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#9A9A9A]">{format.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
